export {
  laysClassic,
  chocolateChipCookie,
  brownie,
  oatmealCookie,
  nutritionCalorieMapping,
} from './constants-shared';

import { mediumFountainDrink as sharedMediumFountainDrink } from './constants-shared';

export const mediumFountainDrink = {
  ...sharedMediumFountainDrink,
  vendorConfigs: {
    ncr: {
      constantPlu: '80121',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
    ncrDelivery: {
      constantPlu: '80121',
      pluType: 'empty',
      pullUpLevels: null,
    },
    toast: {
      constantPlu: '900000000609301741/900000000674059483',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
    toastDelivery: {
      pluType: 'ignore',
    },
  },
};
